import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'myre-nav-dropdown-item',
  templateUrl: './navbar-dropdown-item.component.html',
  styleUrls: ['./navbar-dropdown-item.component.scss'],
  host: { '[attr.myre-button-id]': 'buttonId || null' },
})
export class NavbarDropdownItemComponent {
  @Input()
  public value: any;

  @Input()
  public template: TemplateRef<any>;

  @Input()
  public isSelected: boolean;

  @Input()
  public isFirst: boolean;

  @Input()
  public numberOfNotifications: number;

  @Output()
  public selected: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  public bordered: boolean = true;

  @Input()
  public buttonId: string = '';

  @HostListener('click')
  public onClick(): void {
    this.selected.emit({
      value: this.value,
    });
  }
}
